import { t } from 'i18next'
import { Button } from 'primereact/button'
import React from 'react'
import { API_VERSION } from '../../constants'
import { getCurrentVersion } from '../../util/version'

export const About = (): JSX.Element => {
  return (
    <div className={'card'}>
      <div className="field col-12 mb-2">
        {t<string>('about.description')}

        <div className="grid gap-2 ml-1 mt-2">
          <Button
            className={'p-button-raised p-button-text p-button-warning'}
            type={'button'}
            icon={'fa solid fa-globe'}
            label={'Xenia Software AG'}
            onClick={() => window.open('https://xenia-software.ch')}
          />

          <Button
            className={'p-button-text p-button-raised'}
            type={'button'}
            icon={'fa-solid fa-paper-plane'}
            label={'Support'}
            onClick={() => window.open('mailto:info@xenia-software.ch')}
          />
          <Button
            className={'p-button-text p-button-raised p-button-info'}
            icon={'fa-solid fa-bug'}
            type={'button'}
            label={t<string>('about.feedback')}
            onClick={() => window.open('mailto:dev@xenia-software.ch')}
          />
        </div>
        <span className={'blue-line mt-4 w-full'} />
      </div>
      <div className="col-12 mb-2">
        <h2>{t<string>('about.legal_information')}</h2>

        <div className={'grid inline-grid w-full flex-wrap'}>
          <div className={'col-12 grid'}>
            <b className={'col'}>{t<string>('company.address')}</b>
            <div className={'col-9'}>
              <div>
                <b>Xenia Software AG</b>
              </div>
              <div>Dammstrasse 16</div>
              <div>CH-6300 Zug</div>
            </div>
          </div>

          <div className={'col-12 grid'}>
            <b className={'col'}>
              {t<string>('about.authorised_to_represent')}
            </b>
            <span className={'col-9'}>
              Corina Jaussi{' '}
              <span className={'secondary-text small-text'}>
                ({t<string>('about.ceo')})
              </span>
            </span>
          </div>
          <div className={'col-12 grid'}>
            <b className={'col'}>
              {t<string>('about.commercial_register_number')}
            </b>
            <span className={'col-9'}>CHE-463.750.014</span>
          </div>
          <div className={'col-12 grid'}>
            <b className={'col'}>{t<string>('about.jurisdiction')}</b>
            <span className={'col-9'}>Handelsregisteramt Kanton Zug</span>
          </div>
          <div className={'col-12 grid'}>
            <b className={'col'}>{t<string>('about.liability_notice')}</b>
            <span className={'col-9'}>
              <p>
                <b>DE</b> Trotz sorgfältiger inhaltlicher Kontrolle übernehmen
                wir keine Haftung für die Inhalte externer Links oder
                hochgeladener Fotos der Benutzer. Für den Inhalt der verlinkten
                Seiten und sind ausschliesslich deren Betreiber verantwortlich.
              </p>
              <p>
                <b>FR</b> Malgré un contrôle attentif du contenu, nous déclinons
                toute responsabilité quant aux contenus des liens externes ou
                aux photos téléchargées par les utilisateurs. Les opérateurs des
                sites liés sont seuls responsables du contenu de leurs pages.
              </p>
            </span>
          </div>
        </div>
      </div>

      <div className="col-12 mt-2">
        <span className={'blue-line mb-2 w-full'} />
        <p className={'secondary-text'}>
          Version: {getCurrentVersion()}, api {API_VERSION}
        </p>
      </div>
    </div>
  )
}